import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBooking } from "../../context/BookingContext";
import styles from "../PaymentSuccess/PaymentSuccess.module.css"
import { verifyGripPaymentStaff } from "../../api/api";
import useAuthGuard from "../../hooks/useAuthGuard";

const GripPaymentSuccess = () => {
  useAuthGuard();
  const location = useLocation();
  const navigate = useNavigate();
  const { setBookings } = useBooking();
  const [message, setMessage] = useState("Verifying...");
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    setBookings([]);
    localStorage.removeItem("bookings");

    const query = new URLSearchParams(location.search);
    const freeBooking = query.get("freeBooking");
    const cartId = query.get("cart_id");

    if (freeBooking === "1") {
      setMessage("Your grip booking has been completed successfully.");
      setIsChecking(false);
      return;
    }

    if (!cartId) {
      setTimeout(() => {
        setMessage("Missing payment information. Please try again.");
        setIsChecking(false);
      }, 500);
      return;
    }

    const t = setTimeout(() => {
      verifyGripPaymentStaff(cartId)
        .then((response) => {
          const msg = (response?.data?.message || "").toLowerCase();
          const isOk =
            msg.includes("verified") ||
            msg.includes("successful") ||
            msg.includes("invoice");
          if (isOk) {
            setMessage(
              "Your payment was successful. Your grip booking is now confirmed."
            );
          } else {
            setMessage("Payment verification failed or payment not successful.");
          }
        })
        .catch(() => {
          setMessage(
            "There was an error verifying your payment. Please contact support."
          );
        })
        .finally(() => setIsChecking(false));
    }, 1500);

    return () => clearTimeout(t);
  }, [location.search, setBookings]);

  return (
    <div className={styles.container}>
      <h2>{message}</h2>
      {!isChecking && (
        <div style={{ marginTop: 16 }}>
          <button onClick={() => navigate("/dashboard/booking-customer")}>
            Back to Home
          </button>
        </div>
      )}
    </div>
  );
};

export default GripPaymentSuccess;